<template>
  <div :class="[$style.wrapper, type === 'cheater' && $style.cheater]">
    <div :class="$style.top">
      <span>{{ type === 'cheater' ? 'Злоумышленник' : 'Пользователь' }}:</span>
      <span v-html="icon"></span>
    </div>
    <div :class="$style.title">{{title}}</div>
  </div>
</template>
<script>
import { TweenLite } from 'gsap'

export default {
  name: 'card',
  props: {
    type: String,
    icon: String,
    title: String,
    order: Number,
  },
  methods: {
    reset() {
      this.$el.setAttribute('data-x', 0)
      this.$el.setAttribute('data-y', 0)
      this.$el.dropped = false

      TweenLite.set(this.$el, { x: 0, y: 0, marginRight: 0 })
      TweenLite.to(this.$el, { duration: 0.5, scale: 1 })
    },
  },
  mounted() {
    this.$el.cardObject = {
      title: this.title,
      type: this.type,
      icon: this.icon,
      order: this.order,
      vue: this,
    }
  },
}
</script>
<style lang="scss" module>
$blue: #7395F5;
$red: #FF0000;

.wrapper {
  width: 18rem;
  height: 12rem;
  background: #fff;
  color: #000;
  font-size: 1.4rem;
  line-height: 1.21;
  border-radius: 1rem;
  //box-shadow: 0 0 0 0.3rem inset $blue;
  border: 0.3rem solid $blue;
  padding: 1.2rem;
  flex-shrink: 0;
  touch-action: none;

  & + & {
    margin-left: 1rem;
  }

  &:global(.is-dragging) {
    z-index: 10;
  }

  svg {
    path {
      fill: $blue;
    }
  }

}

.cheater {
  border: 0.3rem solid $red;
  //box-shadow: 0 0 0 0.3rem inset $red;

  .top {
    color: $red;
  }
  svg {
    path {
      fill: $red;
    }
  }
}

.top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: $blue;

  svg {
    height: 2rem;
    width: auto;
  }
}

.title {
  font-size: 1.4rem;
  margin-top: 1rem;
}
</style>
